<template>
    <div class="relative flex flex-row w-full h-12 mt-1 bg-transparent border rounded-full border-polgrey-medium">
      
      <!-- Deincrement -->
      <button type="button" @click="deincrement()" class="w-10 md:w-20 h-full border-r rounded-l-full outline-none cursor-pointer border-polgrey-medium text-polred hover:bg-polgrey">
        <span class="m-auto text-3xl font-thin">−</span>
      </button>

      <input tabindex="0" v-model.number="modelProp" :max="max" :min="min" type="number" class="flex items-center w-10 md:w-full font-semibold text-center bg-transparent outline-none cursor-default focus:outline-none text-md hover:text-black md:text-base">

      <!-- Increment -->
      <button type="button" @click="increment()" class="w-10 md:w-20 h-full border-l rounded-r-full cursor-pointer border-polgrey-medium text-polred hover:bg-polgrey">
        <span class="m-auto text-3xl font-thin">+</span>
      </button>

    </div>
</template>

<script>
export default {
  name: 'TimeAtAddress',
  props: ['model', 'max', 'min'],
  data() {
    return {
      modelProp: 0
    }
  },
  mounted() {
    this.modelProp = this.min ? this.min : this.model
  },
  methods: {
    increment() {
      if (this.max > this.modelProp) {
        this.modelProp += 1
      }
    },
    deincrement() {

      let minVal = this.min ? this.min : 0

      if (minVal < this.modelProp) {
        this.modelProp -= 1
      }
    }
  },
  watch: {
    modelProp: function(val) {
      let value = parseInt(val)
      if (this.max >= value) {
        this.$emit('update:model', value)
      }
      if (this.min >= value) {
        this.$emit('update:model', value)
      }
    }
  }
}
</script>

